import React from "react"

export default function ContentArea(props:any) {
  return <div className='my-36 w-screen'>
    <h1 className='font-family-bungee text-3xl text-center border-b-4 md:text-xl'>{props.label}</h1>
    <div className='font-family-fira-sans text-lg '>
      <props.Content/>
    </div>
  </div>
}
